<template>
  <div class="ApplyNoalert">
    <div v-if="centerDialogVisible">
      <el-dialog
        title="申诉原因"
        :visible.sync="centerDialogVisible"
        center
        width="44%"
      >
        <el-form :model="formData" ref="formData">
          <el-form-item label="">
            <el-input
              type="textarea"
              placeholder="请输入原因"
              v-model="formData.desc"
              :rows="8"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="upload" style="margin-top: 20px; line-height: 25px">
          <el-upload
            class="upload-demo"
            ref="upload"
            :limit="5"
            :action="upload.url"
            :disabled="upload.isUploading"
            :auto-upload="false"
            :data="{ projectId: projectId }"
            :on-progress="handleFileProgress"
            :on-success="handleFileSuccess"
            :on-exceed="handleFileExceed"
          >
            <el-link type="primary" :underline="false"
              ><i class="el-icon el-icon-upload2"></i> 证明材料</el-link
            >
          </el-upload>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="classSubmitForm">提交</el-button>
          <el-button @click="centerDialogVisible = false">取消</el-button>
        </span>
      </el-dialog>
    </div>
    <div v-else>
      <el-dialog
        title="上传收款收据"
        :visible.sync="upload.open"
        center
        width="44%"
      >
        <div class="dialog_content">
          <div class="upload" style="margin-top: 20px; line-height: 25px">
            <div>请上传需要上传的文件（PDG、PNG、JPG）</div>
            <el-upload
              style="margin-top: 20px"
              class="upload-demo"
              ref="upload"
              :limit="5"
              accept=".jpg, .png, .pdg"
              :action="upload.url"
              :disabled="upload.isUploading"
              :auto-upload="false"
              :data="{ projectId: projectId }"
              :on-progress="handleFileProgress"
              :on-success="handleFileSuccess"
              :on-exceed="handleFileExceed"
            >
              <el-link type="primary" :underline="false">点击上传</el-link>
            </el-upload>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitFileForm">确定</el-button>
          <el-button @click="upload.open = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  name: "ApplyNoalert",
  data() {
    return {
      id: "",
      upload: {
        // 是否显示弹出层
        open: false,
        // 是否禁用上传
        isUploading: false,
        // 上传的地址
        url: this.mainBaseURL + "/fixedAssetsManagement/importFixedAssets",
      },
      projectId: "",
      type: 1,
      centerDialogVisible: false,
      formData: {
        desc: "",
      },
    };
  },
  methods: {
    handleFileSuccess(response, file, fileList) {
      if (response.code == "00000") {
        this.upload.open = false;
        this.upload.isUploading = false;
        this.$refs.upload.clearFiles();
        this.importOpen = true;
        this.importData = response.data.errorList;
        this.importSucceedNumber = response.data.succeedNumber;
        this.importErrorNumber = response.data.errorNumber;
        this.getList();
      } else {
        this.upload.isUploading = false;
        this.$refs.upload.abort();
        this.$message.error(response.msg);
      }
    },
    handleFileProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    classSubmitForm() {
      this.$refs["formData"].validate((valid) => {
        if (valid) {
          this.centerDialogVisible = false;
        } else {
          return false;
        }
      });
    },
    handleFileExceed(response) {
      this.$alert("只能上传五个文件");
    },
    show(obj) {
      this.id = obj.id;
      if (obj.type == 1) {
        this.centerDialogVisible = true;
      } else {
        this.upload.open = true;
      }
    },
    submitFileForm() {
      this.upload.open = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.ApplyNoalert {
  // padding: 20px 30px;
  ::v-deep {
    .el-dialog--center .el-dialog__body {
      padding: 25px 50px 35px;
    }
    .el-link.el-link--primary {
      border: 1px solid #4988df;
      background: #4988df;
      padding: 3px 10px;
      color: #fff;
    }
  }
}
</style>
